import { render, staticRenderFns } from "./LogoTitleBlock.vue?vue&type=template&id=502188e3&scoped=true"
import script from "./LogoTitleBlock.vue?vue&type=script&lang=ts"
export * from "./LogoTitleBlock.vue?vue&type=script&lang=ts"
import style0 from "./LogoTitleBlock.vue?vue&type=style&index=0&id=502188e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502188e3",
  null
  
)

export default component.exports